module.exports = __webpack_public_path__ + "assets/img/fairown-granngarden-snow-blower-hero.5a04d6e4.jpg";